import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FeaapplicationService, FeaApplication } from '../../../shared/services/feaapplication.service';
import { AuthService } from '../../../shared/services/auth.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

interface AdminApp extends FeaApplication {
  id: string; 
  status?: string; 
  reviewReason?: string; 
  attachmentUrl?: string;
  fullName: string;
  email: string;
  phone?: string;
  city: string;
  dateOfBirth: string;
  education: string;
  fieldOfStudy: string;
  technicalExperience: string;
  trackInterest: string;
  employmentStatus: string;
  whyInterested: string;
  problemSolve: string;
  fullCommitment: string;
  challenges: string;
  overcomeChallenges: string;
  disciplineWilling: string;
  whySelect: string;
  commitmentAgreement: string;
  createdAt: any;
  }

@Component({
  selector: 'app-feaapplicationreview',
  templateUrl: './feaapplicationreview.component.html',
  styleUrls: ['./feaapplicationreview.component.css']
})
export class FeaapplicationreviewComponent implements OnInit {
  applications: AdminApp[] = [];
  loading = false;
  loadingStatus: 'accepted' | 'rejected' | null = null;
  selectedApp: AdminApp | null = null;
  reviewReason = '';
  selectedFile: File | null = null;
  @ViewChild('reviewModal', { static: false }) reviewModal: TemplateRef<any>;
  @ViewChild('responsesModal', { static: false }) responsesModal: TemplateRef<any>;
  private modalRef: NgbModalRef | null = null;

  constructor(private appService: FeaapplicationService, public authService: AuthService, private modalService: NgbModal) { }

  ngOnInit(): void {
    if (!this.authService.isAdmin()) {
      return;
    }
    this.loading = true;
    this.appService.getApplicationsForAdmin('admin').subscribe(list => {
      this.applications = list as AdminApp[];
      this.loading = false;
    }, err => {
      console.error('Failed to load applications', err);
      this.loading = false;
    });
  }

  openReview(app: AdminApp) {
    this.selectedApp = app;
    this.reviewReason = app.reviewReason || '';
    this.selectedFile = null;
    this.modalRef = this.modalService.open(this.reviewModal, { size: 'lg' });
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.selectedFile = input.files[0];
    }
  }

  async submitReviewOld(status: 'accepted' | 'rejected') {
    if (!this.selectedApp) { return; }
    const id = this.selectedApp.id;
    const reviewer = localStorage.getItem('useremail') || 'admin';
    let attachmentUrl: string | undefined;
    try {
      if (this.selectedFile) {
        attachmentUrl = await this.appService.uploadAttachment(id, this.selectedFile);
      }
      await this.appService.updateApplicationStatus(id, status, { reviewer, reason: this.reviewReason, attachmentUrl });
      // update local state
      this.selectedApp.status = status;
      this.selectedApp.reviewReason = this.reviewReason;
      if (attachmentUrl) this.selectedApp.attachmentUrl = attachmentUrl;
      // close modal and reset
      this.modalRef?.close();
      this.modalRef = null;
      this.selectedApp = null;
      this.selectedFile = null;
      this.reviewReason = '';
    } catch (e) {
      console.error('Failed to submit review', e);
      throw e;
    }
  }

  async submitReview(status: 'accepted' | 'rejected') {

  if (!this.selectedApp || this.loadingStatus) return;

  this.loadingStatus = status;

  const id = this.selectedApp.id;
  const reviewer = localStorage.getItem('useremail') || 'admin';
  let attachmentUrl: string | undefined;

  try {

    if (this.selectedFile) {
      attachmentUrl = await this.appService.uploadAttachment(id, this.selectedFile);
    }

    await this.appService.updateApplicationStatus(
      id,
      status,
      { reviewer, reason: this.reviewReason, attachmentUrl }
    );

    // update local state
    this.selectedApp.status = status;
    this.selectedApp.reviewReason = this.reviewReason;

    if (attachmentUrl) {
      this.selectedApp.attachmentUrl = attachmentUrl;
    }

    // close modal and reset
    this.modalRef?.close();
    this.modalRef = null;
    this.selectedApp = null;
    this.selectedFile = null;
    this.reviewReason = '';

  } catch (e) {
    console.error('Failed to submit review', e);
  } finally {
    // 🔥 ALWAYS reset loader
    this.loadingStatus = null;
  }
}
  viewApplicantResponses() {
    if (!this.selectedApp) { return; }
    this.modalRef = this.modalService.open(this.responsesModal, { size: 'lg' });
  }

  responseKeys(): string[] {
    if (!this.selectedApp) { return []; }
    // Exclude admin metadata fields
    const exclude = ['id', 'status', 'reviewReason', 'attachmentUrl'];
    return Object.keys(this.selectedApp).filter(k => !exclude.includes(k));
  }

}
